module.exports = __webpack_public_path__ + "img/9-black.f26fe37b.png";